import React from 'react';
import ReactDOM from 'react-dom';

class UploadFileComponent extends React.Component {
    constructor(props) {
        super(props);
        this.input;
        this.file;
        this.state = {
            files: [],
            xhrList: 0,
            currentXHRId: '',
            uploadProgress: 0,
            uploadError: false,
            uploadCompleted: false
        };
    }

    componentDidMount() {
        this.input = ReactDOM.findDOMNode(this).querySelector('[name=ajax-upload-file-input]');
    }

    _handleOnFilesAdded() {
        let input = ReactDOM.findDOMNode(this).querySelector('[name=ajax-upload-file-input]');
        this.setState({
            files: input.files,
            uploadProgress: 0,
            uploadCompleted: false
        });
        this.files = input.files
        this.performUpload();
    }

    appendFieldsToFormData = (formData) => {
        const field = typeof this.body === 'function' ? this.body() : this.body;
        if (field) {
            Object.keys(field).forEach((index) => {
                formData.append(index, field[index]);
            });
        }
        return formData;
    }

    performUpload() {
        if (!this.files || !this.files.length) return false;

        let formData = new FormData();
        formData = this.appendFieldsToFormData(formData);

        for (let i = this.files.length - 1; i >= 0; i--) {
            const file = this.files[i];
            this.file = file;
            formData.append('filesToUpload', file);
        }

        let baseUrl = this.props.video ? 'http://www.wblocks.com/hondaAPI/utils/upload.php?video=true' : this.props.cover ? 'http://www.wblocks.com/hondaAPI/utils/upload.php?cover=true' : 'http://www.wblocks.com/hondaAPI/utils/upload.php';
        /* url query*/

        const targetUrl = `${baseUrl}`;

        const xhr = new XMLHttpRequest();
        xhr.open('post', targetUrl, true);
        xhr.upload.addEventListener('progress', (progress) => {
            let uploaded = (progress.loaded / progress.total) * 100;
            this.setState({
                uploadProgress: uploaded
            });
        }, false);

        xhr.addEventListener('load', () => {
            //const res = JSON.parse(xhr.responseText);
            this.setState({
                uploadProgress: 100,
                uploadCompleted: true
            });
        });

        xhr.addEventListener('error', () => {
            const err = JSON.parse(xhr.responseText);
            this.setState({
                uploadProgress: 0,
                uploadError: err
            })
        });

        const curId = this.state.xhrList.length - 1;
        xhr.addEventListener('abort', () => {
            this.onAbort(curId);
        });

        xhr.send(formData);

        this.setState({
            currentXHRId: curId,
            xhrList: [...this.state.xhrList, xhr]
        });

        /* trigger didUpload */
        //this.didUpload(this.files, this.state.currentXHRId);

        return true;
    }


    render() {
        let thumbnail = 
        this.state.uploadCompleted ?
            this.props.video ?
                <video controls src={'http://www.wblocks.com/hondaAPI/articles/temp/video/' + this.file.name}></video>
                :
                this.props.type === 'cover' ?
                    <img src={'http://www.wblocks.com/hondaAPI/articles/temp/photos/0_cover.' + this.file.name.split('.').pop()} />
                    :
                    <img src={'http://www.wblocks.com/hondaAPI/articles/temp/photos/' + this.file.name} />
            :
        '';
        return (
            <div className={ this.props.type === 'cover' ? 'upload-component cover' : 'upload-component' }>
                { this.state.uploadProgress === 0 ?
                <label className="upload-button">
                    < input type="file" name="ajax-upload-file-input" onChange={this._handleOnFilesAdded.bind(this)} />
                    <i className="material-icons right">note_add</i>
                    <span>{ this.props.text ? this.props.text : 'Agregar foto' }</span>
                </label>
                :
                !this.state.uploadCompleted ?
                <div className="upload-progress">
                    <div className="progress">
                        <div className="determinate" style={{ width: this.state.uploadProgress + '%' }}></div>
                    </div>
                    <span>{Math.floor(this.state.uploadProgress) + '%'}</span>
                </div>
                : thumbnail
                }
            </div>
        );
    }
}

export default UploadFileComponent;


// WEBPACK FOOTER //
// ./src/components/UploadFileComponent.js